import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IoniconsOutline, ViewMode, ViewModeButton } from '@pt/pt-models';

@Component({
  selector: 'pt-template-editor-view-selector',
  template: `
    <div class="view-mode-button-container">
      <div class="btn-group btn-group-sm" role="group">
        <button *ngFor="let button of buttonViewMode"
                type="button"
                [ngClass]="button.actived ? 'btn-primary' : 'btn-outline-primary'"
                [disabled]="button.disabled"
                ngbTooltip="{{button.tooltip | async}}"
                (click)="changeViewMode.emit(button.mode)"
                class="btn btn-sm">
          <pt-icon
            [key]="button.icon">
          </pt-icon>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .view-mode-button-container {
      margin-bottom: 5px;
      width: 100%;
      height: 28px;
      text-align: right;
    }

    .view-mode-button-container button {
      width: 40px;
      height: 28px;
    }

    .view-mode-button-container .button-spinner {
      position: absolute;
      left: 14px;
      top: 8px;
      width: 10px;
      height: 10px;
    }
  `]
})
export class TemplateEditorViewSelectorComponent implements OnChanges {
  @Input() selectedViewMode: ViewMode = ViewMode.LIST;

  @Input() disabledTabMode: boolean;
  @Input() disabledTabWithoutMode: boolean;
  @Input() disabledListMode: boolean;
  @Output() changeViewMode = new EventEmitter<ViewMode>();

  buttonViewMode: ViewModeButton[] = [];

  constructor(private translate: TranslateService) {
    const tab = {
      icon: IoniconsOutline.tab,
      tooltip: translate.stream('TOOLTIP.TAB_BUTTON'),
      mode: ViewMode.TAB,
      disabled: this.disabledTabMode,
      actived: false
    };
    // const tabWithoutArrow = {
    //   icon: IoniconsOutline.tabWithoutArrow,
    //   tooltip: translate.stream('TOOLTIP.TAB_WITHOUT_ARROW_BUTTON'),
    //   mode: ViewMode.TAB_WITHOUT_ARROW,
    //   disabled: this.disabledTabWithoutMode,
    //   actived: false
    // };
    const list = {
      icon: IoniconsOutline.list,
      tooltip: translate.stream('TOOLTIP.TAB_LIST_BUTTON'),
      mode: ViewMode.LIST,
      disabled: this.disabledListMode,
      actived: false
    };
    this.buttonViewMode = [tab, list]; // [tab, tabWithoutArrow, list];

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buttonViewMode?.forEach((button: ViewModeButton) => {
      button.actived = this.selectedViewMode && this.selectedViewMode === button.mode;
      switch (button.mode) {
        case ViewMode.LIST:
          button.disabled = this.disabledListMode;
          break;

        case ViewMode.TAB:
          button.disabled = this.disabledTabMode;
          break;
      }
    });
  }
}

